import React, { useEffect, useState, useRef } from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import endPoints from '../../../../api/endpoint';
import { useNavigate } from 'react-router-dom';
import { getApiCallNew } from '../../../../api/methods';
import Loading from '../../../../Components/Loading';
import NoData from '../../../../Components/Nodata';
import ContactCard from '../../../../Components/ContactCard';

interface DraftModalProps {
  open: boolean;
  onClose: () => void;
}

const DraftModal: React.FC<DraftModalProps> = ({ open, onClose }) => {
  const [drafts, setDrafts] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const limit = 10;

  const fetchDrafts = async (pageNo = 1) => {
    if (pageNo === 1) {
      setInitialLoading(true);
    }
    setLoading(true);
    try {
      const {
        data: response,
        success,
        fullData,
      } = await getApiCallNew(
        `${endPoints.riskSecurity.getDraftList}?page=${pageNo}&limit=${limit}`,
      );

      console.log(fullData, 'fullData');

      if (success) {
        const newDrafts = fullData?.data?.data || [];
        setDrafts(prev => (pageNo === 1 ? newDrafts : [...prev, ...newDrafts]));
        setHasMore(fullData?.nextHit || false);
      }
    } catch (err) {
      console.error('Draft fetch error', err);
    } finally {
      setLoading(false);
      if (pageNo === 1) {
        setInitialLoading(false);
      }
    }
  };

  useEffect(() => {
    if (open) {
      setPage(1);
      fetchDrafts(1);
    }
  }, [open]);

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || loading || !hasMore) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 10
    ) {
      setPage(prev => prev + 1);
    }
  };

  useEffect(() => {
    if (page > 1) fetchDrafts(page);
  }, [page]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth className="modal-main">
      <div className="modal-dialog md">
        <div className="modal-content">
          <div className="modal-title d-flex align-center flex-between">
            <p className="fw600 MuiTypography-body2">Saved Drafts</p>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>

          {initialLoading ? (
            <Loading type="div" height="auto" />
          ) : drafts?.length > 0 ? (
            <div
              className="modal-body body-scroll-sm"
              ref={containerRef}
              onScroll={handleScroll}
            >
              {drafts.map((draft: any, idx: number) => (
                <div key={draft._id || idx}>
                  <ContactCard draft={draft} />
                </div>
              ))}

              {loading && <Loading type="div" height="auto" />}
            </div>
          ) : (
            <NoData
              heading="No Drafts Found"
              title="There are no records of drafts yet"
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DraftModal;
